import { services } from '../data/services';
import { CTABand, PageShell } from '../components/Chrome';

export function ServicesPage() {
  return (
    <PageShell active="services" cta={<CTABand heading="Problem not on the list?" sub="That is normal. Start with what is happening and we will work out the category later." />}>
      <section className="site-wrap page-head">
        <div className="overline">Services</div>
        <h1>Bring us the problem. We will pick the tool.</h1>
        <p className="hero-sub">Here is what comes up most often. Real jobs rarely fit one tidy category, so this is a starting point rather than a boundary.</p>
      </section>
      <section className="site-wrap svc-rows">
        {services.map((service) => (
          <div className="svc-row" key={service.id} id={service.id}>
            <div className="svc-row-name"><h2>{service.name}</h2></div>
            <div className="svc-row-body">
              <p>{service.blurb}</p>
              <ul className="sym-list">
                {service.symptoms.map((item) => <li key={item}><span className="li-glyph" aria-hidden="true">▸</span><span>{item}</span></li>)}
              </ul>
              <a className="more-link" href={`/services/${service.id}/`}>More on {service.short} →</a>
            </div>
          </div>
        ))}
      </section>
    </PageShell>
  );
}
